const groupPrefix = createApiRoute(ApiModule.SUPPLIER, ApiAuthorization.EMPLOYEE)

export const apiSuppliers = {
	fetchActiveSuppliers: async (
		page: number,
		perPage: number,
		query: string | undefined,
		isActive: boolean,
	): Promise<IApiResponseModel<ISupplierModel[]>> => {
		const { data, meta } = await apiCommon<ISupplier[]>(`${groupPrefix}/list`, {
			method: 'GET',
			...createQuery({ page, perPage }, undefined, undefined, { is_active: isActive, query }),
		})

		return { data: data.map(d => Suppliers(d)), meta }
	},

	createNewSupplier: async (supplier: ISupplierModel): Promise<IApiResponseModel<ISupplierModel>> => {
		const obj = supplierModelToJSON(supplier)
		const { data, meta } = await apiCommon<ISupplier>(`${groupPrefix}/add`, {
			method: 'POST',
			body: obj,
		})

		return { data: Suppliers(data), meta }
	},

	archiveSupplier: async (id: number): Promise<void> => {
		await apiCommon<string>(`${groupPrefix}/${id}/archive`, {
			method: 'POST',
		})
	},

	activateSupplier: async (id: number): Promise<void> => {
		await apiCommon<string>(`${groupPrefix}/${id}/activate`, {
			method: 'POST',
		})
	},

	updateSupplier: async (supplier: ISupplierModel, id: number): Promise<IApiResponseModel<ISupplierModel>> => {
		const { data, meta } = await apiCommon<ISupplier>(`${groupPrefix}/${id}`, {
			method: 'PUT',
			body: supplier,
		})

		return { data: Suppliers(data), meta }
	},

	deleteSupplier: async (id: number): Promise<void> => {
		await apiCommon<string>(`${groupPrefix}/${id}`, {
			method: 'DELETE',
		})
	},
}
